/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../../apiResponse';
import { createApiResponseSchema } from '../../../apiResponse';
import { logLevelSchema } from './create-debug-request';

export const createDebugResponseDataSchema = z.object({
  level: logLevelSchema,
  message: z.string(),
  category: z.array(z.string()),
});

export type ICreateDebugResponseData = z.infer<typeof createDebugResponseDataSchema>;

export const createDebugResponseSchema = createApiResponseSchema(
  createDebugResponseDataSchema,
) as z.ZodSchema<IAPI<ICreateDebugResponseData>>;

export type ICreateDebugResponse = IAPI<ICreateDebugResponseData>;
